/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Desk_VolumeInputs */

const en_features_desk_volume = /** @type {(inputs: Features_Desk_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume`)
};

const pl_features_desk_volume = /** @type {(inputs: Features_Desk_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objętość`)
};

/**
* | output |
* | --- |
* | "Volume" |
*
* @param {Features_Desk_VolumeInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_desk_volume = /** @type {((inputs?: Features_Desk_VolumeInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Desk_VolumeInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_desk_volume(inputs)
	return en_features_desk_volume(inputs)
});